/* eslint-disable @angular-eslint/component-class-suffix */
import {
    BankFormFields, CustomerType, DisplayValue, EmploymentFormFields, FileFormFields, IdentificationType, LoanFormFields, MaritalStatus,
    BasePatientDetailsFormFields, PayCycle, Resource, SignatureFormFields, Title, PatientDetailsFormFields, Bank, VendorApplication,
    BankAccountType, VendorAgent, VendorApplicationCustomer, Vendor, VendorApplicationCustomerResource,
    DocumentTypeEnum, LoanStartDateOptions,
    SigningMethod,
    TableDatumType
} from "common";
import { IdTypeOptions, MaritalStatuses, MonthlyPayDateOptions, PayCyclesOptions, BankAccountTypesOptions, StaticBankList, TitleOptions, WeeklyPayDateOptions, CustomCurrencyMaskConfig, VENDOR_MAX_LOAN_AMOUNT } from "../../../utils/constants";
import { Observable, Subject, Subscription, catchError, combineLatest, debounceTime, filter, firstValueFrom, map, of, skip, skipWhile, startWith, switchMap, takeUntil } from "rxjs";
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { AsyncPipe, DatePipe, DecimalPipe, DOCUMENT, NgClass, NgIf, NgTemplateOutlet, TitleCasePipe } from "@angular/common";
import { Component, HostListener, Inject, OnDestroy, OnInit, ViewChild, inject, signal } from "@angular/core";
import { PhoneNumberValidator, accountHolderIdNotSameAsCustomerIdValidator, bankDetailsSyncValidator, isRSAIdentity } from "../../../utils/validators";
import { SigningAccordionComponent } from "./signing-accordion/signing-accordion.component";
import { YearMonthPickerComponent } from "./year-month-picker/year-month-picker.component";
import { ViewPrintEmailDialog } from "../view-print-email.dialog/view-print-email.dialog";
import { ResourceViewerComponent } from "../../resource-viewer/resource-viewer.component";
import { SelectVendorAgentDialog } from "../select-agent-dialog/select-agent-dialog";
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from "@angular/material/dialog";
import { FileAccordionComponent } from "./file-accordion/file-accordion.component";
import { STEPPER_GLOBAL_OPTIONS, StepperOrientation } from "@angular/cdk/stepper";
import { PhoneFormatDirective } from "../../../directives/phone-number.directive";
import { SnackMessageComponent } from "../../snackbars/snack-message.component";
import { formatBytes, toNth, toTitle } from "../../../utils/static-functions";
import { CURRENCY_MASK_CONFIG, CurrencyMaskModule } from "ng2-currency-mask";
import { animate, style, transition, trigger } from "@angular/animations";
import { SharedApiService } from "../../../services/shared-api.service";
import { CaptureSaveService } from "./capture-save.service";
import { BankDetailsValidator } from "../../../utils/async-validators";
import { MatSlideToggleChange } from "@angular/material/slide-toggle";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatProgressBarModule } from "@angular/material/progress-bar";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatDividerModule } from "@angular/material/divider";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatStepperModule } from "@angular/material/stepper";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSelectModule } from "@angular/material/select";
import { MatButtonModule } from "@angular/material/button";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { FileService } from "../../../services/file.service";
import { MatSelectChange } from "@angular/material/select";
import { MatSnackBar } from "@angular/material/snack-bar";
import { BreakpointObserver } from "@angular/cdk/layout";
import { MatStepper } from "@angular/material/stepper";
import { ConfirmDialog } from "../confirm.dialog";
import dayjs from 'dayjs';


// signing method is not detected by application state.
// chrome auto downloading the file.

interface AccountHolderDeleteContext {
    kind: 'accountHolder';
    toggleSource?: { checked: boolean; };
}

@Component({
    selector: 'lib-capture.dialog',
    templateUrl: './capture.dialog.html',
    styleUrls: ['./capture.dialog.scss'],
    standalone: true,
    providers: [
        { provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true, displayDefaultIndicatorType: false } },
        { provide: CURRENCY_MASK_CONFIG, useValue: CustomCurrencyMaskConfig },
        MatSnackBar,
    ],
    imports: [
        // Angular imports.
        AsyncPipe, DatePipe, DecimalPipe, TitleCasePipe, NgClass, NgIf, NgTemplateOutlet, ReactiveFormsModule, CurrencyMaskModule,
        MatDialogModule, MatButtonModule, MatIconModule, MatFormFieldModule, MatInputModule, MatSelectModule,
        MatProgressBarModule, MatProgressSpinnerModule, MatSlideToggleModule, MatStepperModule, MatExpansionModule,
        MatDividerModule, MatTooltipModule,
        // Custom imports/components.
        PhoneFormatDirective, FileAccordionComponent, SigningAccordionComponent,
        YearMonthPickerComponent, ResourceViewerComponent
    ],
    animations: [
        trigger(
            'slideFadeInOut',
            [
                transition(
                    ':enter', [
                    style({ height: 0, opacity: 0 }),
                    animate('0.3s ease-out',
                        style({ height: '{{height}}', opacity: 1 }))
                ]),
                transition(
                    ':leave', [
                    style({ height: '{{height}}', opacity: 1 }),
                    animate('0.3s ease-in',
                        style({ height: 0, opacity: 0 }))
                ])
            ]
        ),
        trigger(
            'fadeInOut',
            [
                transition(
                    ':enter', [
                    style({ opacity: 0 }),
                    animate('0.3s ease-out',
                        style({ opacity: 1 }))
                ]),
                transition(
                    ':leave', [
                    style({ opacity: 1 }),
                    animate('0.3s ease-in',
                        style({ opacity: 0 }))
                ])
            ]
        )
    ]
})
export class CaptureDialog implements OnInit, OnDestroy {
    //#region Variables
    // Variables for this component that are within scope of "this" component.

    public form = this.fb.group({
        // Customer Information
        customerInformation: this.newPersonalDetailsForm(CustomerType.DebtorAndAuthorizer),

        // Employment Information
        employment: this.fb.group<EmploymentFormFields>({
            designation: new FormControl<string | null>(null),
            employeeNumber: new FormControl<string | null>(null),
            employer: new FormControl<string | null>(null, Validators.required),
            employerAddress: new FormControl<string | null>(null),
            employerBranch: new FormControl<string | null>(null),
            employerTelephone: new FormControl<string | null>(null, Validators.compose([Validators.required, PhoneNumberValidator('ZA')])),
            employerPostalCode: new FormControl<string | null>(null),
            employmentStartDate: new FormControl<Date | null>(null, Validators.required), // Should always be a past date.
            payCycleId: new FormControl<PayCycle | null>(null, Validators.compose([Validators.required, Validators.min(1)])),
            payDay: new FormControl<number | null>(null, Validators.compose([Validators.required])),
        }),

        // Patient Information - Add more patients when needed.
        patients: this.fb.array<BasePatientDetailsFormFields>([]),

        // Bank Information
        bankDetails: this.fb.group({ // The deprecation warning is not a concern, as it's regarding type-safety.
            bankId: new FormControl<number | null>(null, Validators.compose([Validators.required])),
            branchCode: new FormControl<string | null>(null, Validators.compose([Validators.required, Validators.minLength(3)])),
            bankAccountType: new FormControl<BankAccountType | null>(null, Validators.compose([Validators.required])),
            bankAccountNumber: new FormControl<string | null>(null, Validators.compose([Validators.required, Validators.minLength(7)])),

            // Add toggle to allow changing the customer from 7 to X where holder can be captured separately.
            // Holder can be firstname, surname, idnumber, customer type = 5.
            // Optional fields. Only required when the account holder is different from the customer.
            accountHolderFirstName: new FormControl<string | null>(null), // Optional fields.
            accountHolderLastName: new FormControl<string | null>(null), // Optional fields.
            accountHolderIdentityType: new FormControl<IdentificationType | null>(null), // Optional fields.
            accountHolderIdentityNumber: new FormControl<string | null>(null), // Optional fields.
            accountHolderEntityId: new FormControl<number | null>(null), // Not shown, only to hold the entity's ID.
        }, {
            validators: [bankDetailsSyncValidator, accountHolderIdNotSameAsCustomerIdValidator()],
            asyncValidators: [this.bankDetailsValidator.validate.bind(this.bankDetailsValidator)]
        }),

        // Loan Information
        loan: this.fb.group<LoanFormFields>({
            loanAmount: new FormControl<number | null>(null, Validators.compose([Validators.required, Validators.min(1), Validators.max(VENDOR_MAX_LOAN_AMOUNT)])),
            startDate: new FormControl<Date | null>(null, Validators.compose([Validators.required])),
            /**
             * @important - No. of installments.
             * Monthly paid: between 1 and 6. 
             * Weekly paid: between 1 and 24. 
             * Fortnightly paid: between 1 and 12. 
             */
            instalments: new FormControl<number | null>(null, Validators.compose([Validators.required, Validators.min(1)])),

            initiationFee: new FormControl<number | null>(null), // Readonly, From Vendor
            administrationFee: new FormControl<number | null>(null), // Readonly, Calculated From Vendor
            instalment: new FormControl<number | null>(null), // Readonly, Calculated

        }),

        // Document Uploads
        files: this.fb.group<FileFormFields>({
            photoPayslipId: new FormControl<number | null>(null),
            photoPayslip: new FormControl<Resource | null>(null),
            loanAgreementId: new FormControl<number | null>(null),
            loanAgreement: new FormControl<Resource | null>(null),
        }),

        // Signatures of the Customer.
        signatures: this.fb.group<SignatureFormFields>({
            agreeFirstInstalment: new FormControl<boolean | null>(false),
            agreeMandate: new FormControl<boolean | null>(false),
            agreeMarketing: new FormControl<boolean | null>(false),
            agreeTermsSpecsfin: new FormControl<boolean | null>(false),
            notUnderReview: new FormControl<boolean | null>(false),
            signatureMandate: new FormControl<Resource | null>(null),
            signatureMandateId: new FormControl<number | null>(null),
            signatureQuotation: new FormControl<Resource | null>(null),
            signatureQuotationId: new FormControl<number | null>(null),
            signatureTerms: new FormControl<Resource | null>(null),
            signatureTermsId: new FormControl<number | null>(null),
        }),

        // Auto-populated after first save.
        debtorCustomerId: null as number | null,
        bankAccountCustomerId: null as number | null,
        reference: null as string | null,
        id: null as null | number,
        vendor: null as null | number,
        // Auto-populated on open.
        agent: new FormControl<number | null>(null, Validators.required),
    });

    /**
     * Short reference of the customer info form group.
     * Original member of the `form` group.
     */
    public customerForm = this.form.get('customerInformation') as FormGroup<PatientDetailsFormFields>;
    // public customerForm = this.form.get('customerInformation') as FormGroup<CustomerPatientDetailsFormFields>;

    /**
     * Short reference of the employments form group.
     * Original member of the `form` group.
     */
    public employmentForm = this.form.get('employment') as FormGroup<EmploymentFormFields>;

    /**
     * Short reference of the bank details form group.
     * Original member of the `form` group.
     */
    public bankForm = this.form.get('bankDetails') as FormGroup<BankFormFields>;

    /**
     * Short reference of the loan form group.
     * Original member of the `form` group.
     */
    public loanForm = this.form.get('loan') as FormGroup<LoanFormFields>;

    /**
     * This form is not filled in by the user, rather it's used to validate all 
     * the patients against it and be consumed by the mat stepper.
     *
     * The support for the MatStepper when it comes to FormArray is limited, and
     * it's not possible without having each step represent each entry in the array.
     * 
     * Thus, we have a single form that will be used to validate all the patients
     * and update the MatStepper based on the validity of it/all patients.
     */
    public patientStepperForm = this.fb.group({
        allPatients: [true, Validators.requiredTrue],
    });

    /**
     * This form is not filled in by the user, rather it's used to validate all
     * the files against it and be consumed by the mat stepper.
     * 
     * These forms are validated manually by the file-accordion component.
     * @see FileAccordionComponent for details.
     * @see updateFileFormsValidity (local method) for details.
     */
    public fileStepperForm = this.fb.group({
        allFiles: [true, Validators.requiredTrue],

        // The idea is that the stepper should mark red for the files form only, and the accordion should mark red for the individual files.
        customerFiles: new FormGroup<any>({}),
        patientFiles: new FormArray<any>([]),
    });

    /**
     * This form is not filled in by the user, rather it's used to bypass
     * the file stepper and be consumed by the mat stepper.
     */
    public fileStepperFormBypass = this.fb.group({
        allFiles: [true],
    });

    /**
     * Used to temporarily bypass the form stepper.
     * The mat form stepper doesn't make this convenient and the validation of the files is handled by the file-accordion component.
     */
    public useFormStepperBypass = false;

    /**
     * This form is not filled in by the user, rather it's used to validate all
     * the signatures against it and be consumed by the mat stepper.
     * 
     * These forms are validated manually by the signing-accordion component.
     * @see SigningAccordionComponent for details.
     * @see updateSignatureFormsValidity (local method) for details.
     */
    public signatureStepperFrom = this.fb.group({
        allSignatures: [true, Validators.requiredTrue],
    });

    /**
     * The options for each material status - imported from constants.
     */
    public maritalStatuses: DisplayValue<MaritalStatus>[] = MaritalStatuses;

    /**
     * Maximum base loan amount, shown in the loan amount error.
     */
    public readonly maxLoanAmount = VENDOR_MAX_LOAN_AMOUNT;

    /**
     * The options for each pay cycles - imported from constants.
     */
    public payCyclesOptions: DisplayValue<PayCycle>[] = PayCyclesOptions;

    /**
     * The options for each monthly pay date - imported from constants.
     */
    public monthlyPayDateOptions: DisplayValue<number>[] = MonthlyPayDateOptions;

    /**
     * The options for each weekly pay date - imported from constants.
     */
    public weeklyPayDateOptions: DisplayValue<number>[] = WeeklyPayDateOptions;

    /**
     * The options for each identification type - imported from constants.
     */
    public idTypeOptions: DisplayValue<IdentificationType>[] = IdTypeOptions;

    /**
     * The options for each title - imported from constants.
     */
    public titleOptions: DisplayValue<Title>[] = TitleOptions;

    /**
     * The options for each bank - received by API.
     */
    public bankOptions: Bank[] = StaticBankList;

    public loanStartDateOptions: DisplayValue<Date>[] = [];

    public loanStartDateEnumOptions: DisplayValue<LoanStartDateOptions>[] = [
        {
            display: 'This Month',
            value: LoanStartDateOptions.ThisMonth
        },
        {
            display: 'Next Month',
            value: LoanStartDateOptions.NextMonth
        },
        {
            display: 'Two Months From Now',
            value: LoanStartDateOptions.TwoMonths
        },
        {
            display: 'Three Months From Now',
            value: LoanStartDateOptions.ThreeMonths
        },
    ];

    /**
     * Number of installment options for PayCycle.Monthly.
     */
    private monthlyPayCycleInstallments =
        Array.from({ length: 6 }, (_, i) => i + 1)
            .map<DisplayValue<number>>(i => ({ display: i + '', value: i }));

    /**
     * Number of installment options for PayCycle.Weekly.
     */
    private weeklyPayCycleInstallments =
        Array.from({ length: 24 }, (_, i) => i + 1)
            .map<DisplayValue<number>>(i => ({ display: i + '', value: i }));

    /**
     * Number of installment options for PayCycle.Fortnightly.
     */
    private fortnightlyPayCycleInstallments =
        Array.from({ length: 12 }, (_, i) => i + 1)
            .map<DisplayValue<number>>(i => ({ display: i + '', value: i }));

    /**
     * The options for each bank account type - imported from constants.
     * @see BankAccountTypesOptions for more information.
     */
    public bankAccountTypeOptions = BankAccountTypesOptions;

    /**
     * Flag to indicate if the bank details are being validated.
     * Used to show a loading spinner.
     */
    public isValidatingBankDetails = false;

    /**
     * Flag to indicate if the form is in read mode.
     */
    public isReadMode = this.config.readMode;

    /**
     * Flag to indicate if the file forms are valid.
     * Default = true if in read mode.
     * Used for step 6 validation and next button.
     */
    public areFileFormsValid = this.isReadMode;

    /**
     * Flag to indicate if the signature forms are valid.
     * Default = true if in read mode.
     */
    public areSignatureFormsValid = this.isReadMode;

    /**
     * Flag to indicate if the customer is also a patient.
     * When enabled, auto syncs the customer form with the patient form and inserts a new patient form at index 0 of the patients array.
     */
    public isCustomerAPatient = false;

    /**
     * Flag to indicate if the customer is also the account holder.
     */
    public isCustomerTheAccountHolder = true;

    /**
     * Flag to indicate if the form is submitting.
     */
    public isSubmitting = false;

    /** 
     * True once Save & Close has queued its save; reset only if that save fails. 
     */
    public isClosing = false;

    /**
     * Flag to indicate if this is a new application.
     */
    private isNewApplication = true;

    /**
     * Flag to indicate if the quote is being downloaded.
     * Used to disable the download button.
     */
    public isDownloadingQuote = false;

    /**
     * Observable to determine the orientation of the stepper.
     *
     * @type {Observable<StepperOrientation>} The orientation of the stepper, either 'horizontal' or 'vertical'.
     */
    public stepperOrientation!: Observable<StepperOrientation>;

    /**
     * Each index will correlate to the subscription that manages the state of each
     * patient form group in the patients array.
     * This is used in conjunction with the functionality of enabling/disabling
     * the identityNumber based on the identityType selected.
     *
     * @note Do not use index -2, as this is reserved for the customer form.
     * @note If the customer is also a patient, there will be a subscription created here and that's ok.
     * @type {Record<string, Subscription>}
     */
    private idStateSubscriptions: Record<string, Subscription> = {};

    /**
     * The name of the agent who's responsible for this application.
     * Shown on the bottom left of the dialog.
     */
    public agentName: string | undefined;

    /**
     * Used to trigger child component to mark the signatures as dirty.
     */
    public invokeMarkSignaturesDirty = false;

    /**
     * The current step of the stepper.
     *
     * @memberof CaptureDialog
     */
    public currentStep = 0;

    /**
     * Indicates whether a save is currently in flight or queued. Delegates to CaptureSaveService
     * so all callers share the same single-flight signal.
     */
    private get isSaving(): boolean { return this.saveService.isSaving; }

    /**
     * An indicator to if the instalment should be calculated after a save.
     * This is so because the instalment is calculated on the server side and in some cases, we can only get the instalment after the application has been saved.
     */
    private calculateAfterSave = false;

    public maySubmit = false;

    public agreeReview = false;

    public showAccountHolderLoader = false;

    public showPatientLoader = false;

    public showLoanLoader = false;

    public reviewModel = signal<{ customer: any, employment: any, loan: any, bankDetails: any, patients: any[], }>({
        customer: {},
        employment: {},
        loan: {},
        bankDetails: {},
        patients: [],
    });

    public loanAgreementModel = signal<{ filename: string, size: string, contentUrl: string; }>({
        filename: '',
        size: '',
        contentUrl: '',
    });

    public signingMethod = SigningMethod.None;

    @ViewChild('stepper') private stepper!: MatStepper;

    /**
     * SSR-safe reference to the local storage.
     */
    private localStorageRef: Storage | undefined = this.document.defaultView?.localStorage;;

    private calculateInstalment$ = new Subject<void>();

    private destroyed$ = new Subject<void>();

    //#endregion

    public dialog = inject(MatDialog);
    public matSnackbar = inject(MatSnackBar);
    public fileService = inject(FileService);
    private apiService = inject(SharedApiService);
    private saveService = inject(CaptureSaveService);

    constructor(
        private fb: FormBuilder,
        private bankDetailsValidator: BankDetailsValidator,
        public dialogRef: MatDialogRef<CaptureDialog>,
        private breakpointObserver: BreakpointObserver,
        @Inject(DOCUMENT) private document: Document,
        @Inject(MAT_DIALOG_DATA) public config: CaptureDialogInputData
    ) { }

    //#region Instantiation
    // Setup\fetches\initialization.

    public ngOnInit() {
        this.stepperOrientation = this.breakpointObserver
            .observe('(min-width: 800px)')
            .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));

        this.fetchBankOptions();

        // console.log('config.application', this.config.application);

        // Load the data into the form if it exists.
        if (this.config.application) {
            this.isNewApplication = false;
            this.loadConfigDataIntoForm();
        }

        // If this is a new application, by default, add one patient.
        else if (!this.isReadMode) {
            this.addPatient(); // Add one patient by default, this is the customer.
            this.isNewApplication = true;

            if (this.config.vendorAgentId !== undefined) {
                this.form.controls['agent'].setValue(this.config.vendorAgentId);

                if (this.config.agent) {
                    this.agentName = this.config.agent.firstName + ' ' + this.config.agent.lastName;
                }
            }

            if (this.config.vendor) {
                this.form.controls['vendor'].setValue(this.config.vendor.id);
                this.loanForm.controls['administrationFee'].setValue(this.config.vendor.administrationFee);
                this.loanForm.controls['initiationFee'].setValue(this.config.vendor.initiationFee);
            }

            if (this.isNewApplication) {
                // Make the customer a patient by default.
                this.onTogglePatientSameAsCustomer({ checked: true, source: null as any });
                // Make the customer the account holder by default.
                this.onToggleAccountHolderSameAsCustomer({ checked: true, source: null as any })
                    .then().catch();
            }
        }

        // Subscribe to form changes if not in readMode.
        if (!this.config.readMode) {
            this.subscribeToFormChanges();
            this.enableAutoSaves();
            this.enableOnCloseConfirmAndSave();
            this.subscribeToSaveResults();
            this.subscribeToDeleteResults();
        }

        this.subscribeToUpdateInstalment();

        // Autofill fields to save time.
        setTimeout(() => {
            // if (this.isNewApplication) {
            // this.loadDummyData();
            // }
            this.setReviewModel();
        }, 450);

        // Set signing method from local storage.
        const signingMethod = this.localStorageRef?.getItem('signingMethod');
        const hasESignatures = this.signatureForm?.get('signatureMandateId')?.value || this.signatureForm?.get('signatureQuotationId')?.value || this.signatureForm?.get('signatureTermsId')?.value;
        const doesNotHaveManualSignedLoanAgreement = !this.form.get('files')?.get('loanAgreementId')?.value;

        // If it's already submitted (isReadMode), set according to the application rather than the local storage.
        if (this.isReadMode) {
            if (hasESignatures && doesNotHaveManualSignedLoanAgreement)
                this.signingMethod = SigningMethod.Electronic;
            else
                this.signingMethod = SigningMethod.Manual;

        } else {
            // Set to Electronic if the loan has been signed electronically.
            if (hasESignatures && doesNotHaveManualSignedLoanAgreement)
                this.signingMethod = SigningMethod.Electronic;
            // Else if the loan has been signed manually, set it to manual.
            else if (!doesNotHaveManualSignedLoanAgreement)
                this.signingMethod = SigningMethod.Manual;
            // Otherwise, set it to what's stored in local storage or leave as default (None).
            else if (signingMethod)
                this.signingMethod = parseInt(signingMethod);
        }

        this.updateManualSigningValidationStatus();
    }

    private loadDummyData() {
        // Patch the customer details.
        this.customerForm.patchValue({
            title: Title.Mr,
            firstName: 'John',
            lastName: 'Doe',
            identityType: IdentificationType.Other,
            customerType: CustomerType.PatientAndDebtor,
            identityNumber: '123456789',
            email: 'mail@email.com',
            mobileNumber: '+27 (79) 730-2588',
            address: '123 Fake Street',
            postalCode: '1234',
            maritalStatus: MaritalStatus.Single,
        });
        this.customerForm.markAllAsTouched();

        // Patch the Employment form.
        this.employmentForm.patchValue({
            designation: 'Developer',
            employeeNumber: '1234',
            employer: 'Ponies',
            employerAddress: 'Something street',
            employerBranch: 'Northlink',
            employerTelephone: '+27 (21) 123-4567',
            employerPostalCode: '1234',
            employmentStartDate: new Date('2021-01-01'),
            payCycleId: PayCycle.Monthly,
            payDay: 28,
        });
        this.employmentForm.markAllAsTouched();

        // Set the Payday again for it to load properly
        setTimeout(() => {
            this.employmentForm.get('payDay')?.setValue(28);
        }, 100);

        // Make the customer and account holder separate.
        // this.onToggleAccountHolderSameAsCustomer({ checked: false, source: null as any });

        const bank = this.bankOptions.find(b => b.id === 2);
        // Patch the bank details.
        this.bankForm.patchValue({
            bankId: bank?.id,
            branchCode: bank?.code,
            bankAccountType: 1,
            bankAccountNumber: '1234567',
            // accountHolderFirstName: 'Jane',
            // accountHolderLastName: 'Doe',
            // accountHolderIdentityType: IdentificationType.RSAID,
            // accountHolderIdentityNumber: '9702285271088',
            // accountHolderEntityId: null
        });
        this.bankForm.markAllAsTouched();

        // Patch loan details.
        this.loanForm.patchValue({
            administrationFee: this.config.vendor?.administrationFee || 135,
            initiationFee: this.config.vendor?.initiationFee || 350,
            loanAmount: 1000,
            instalments: 6,
            instalment: 200,
            startDate: new Date(),
        });
        this.loanForm.markAllAsTouched();


        setTimeout(() => {
            this.customerForm.updateValueAndValidity();
            this.bankForm.updateValueAndValidity();
            this.loanForm.controls['startDate'].setValue(this.loanStartDateOptions[1].value);
        });
    }

    // Listen for escape key to close the dialog and confirm.
    @HostListener('window:keyup.esc', ['$event'])
    async onKeyUp(event: KeyboardEvent) {
        event.stopPropagation();
        this.confirmCloseIfDirty();
    }

    // Listen for browser reload and confirm.
    @HostListener("window:beforeunload", ["$event"]) unloadHandler(event: Event) {
        if (!this.isReadMode && this.form.dirty) {
            event.preventDefault();
        }
    }

    //#endregion
    //#region User Interactions
    // Callbacks from html, anything the user can "interact" with from the view.

    /**
     * Callback for when the user submits the form.
     */
    public onSubmit(): void {
        this.isSubmitting = true;

        const application = this.toVendorApplication();
        this.apiService.submitApplication(application)
            .pipe(catchError(error => {
                console.error('Failed to submit application.', error);
                this.matSnackbar.open('Failed to submit application.', 'Close', { duration: 3000 });
                this.isSubmitting = false;
                return of(null);
            }))
            .subscribe((response) => {
                if (response) {
                    this.matSnackbar.open('Application submitted.', 'Close', { duration: 3000 });
                    this.dialogRef.close(response);
                }
                this.isSubmitting = false;
            });
    }

    /**
     * Requests a quote for the application.
     *
     * @return {Promise<void>} A promise that resolves when the quote has been requested.
     */
    public async onRequestQuote(): Promise<void> {
        const applicationId = this.form.get('id')?.value;
        if (this.form.get('reference')?.value && applicationId) {
            this.isDownloadingQuote = true;
            this.saveApplication();
            await this.saveService.flush();

            // Requires mandatory fields to have been filled
            if (this.customerForm.valid && this.config.vendor?.id) {

                this.apiService.vendorApplicationDocument(DocumentTypeEnum.Quotation, applicationId)
                    .pipe(catchError(error => {
                        console.error('Failed to request a quote.', error);
                        this.matSnackbar.open('Failed to download a quote.', 'Close', { duration: 3000 });
                        this.isDownloadingQuote = false;
                        return of(null);
                    }))
                    .subscribe((base64) => {
                        if (base64) {
                            // Download the base64.
                            const link = document.createElement('a');
                            link.href = 'data:application/pdf;base64,' + base64;
                            link.download = `Quotation${this.form.value.reference ? ' ' + this.form.value.reference : ''} ${dayjs().format('DD-MMM-YYYY HH-mm')}.pdf`;
                            link.click();
                        }
                        this.isDownloadingQuote = false;
                    });
            } else {
                this.isDownloadingQuote = false;
            }
        }
    }

    /**
     * Retries the bank validation process by triggering the valueChanges of the bank details form controls.
     */
    public retryBankValidation(emitEvent = true): void {
        [
            this.bankForm.controls.bankId,
            this.bankForm.controls.branchCode,
            this.bankForm.controls.bankAccountType,
            this.bankForm.controls.bankAccountNumber
        ]
            .forEach(c => c.updateValueAndValidity({ emitEvent }));

    }

    public refreshInstalments() {
        this.calculateInstalment$.next();
    }

    /**
     * Adds a new patient form to the patients array.
     */
    public addPatient(): void {
        const newPatientForm = this.newPersonalDetailsForm(CustomerType.Patient) as unknown as FormGroup<PatientDetailsFormFields>;

        // Add signature fields to patient.
        // Customers do not sign on their own form, they sign onto the signature form.
        // Patients sign on their own form, so we add the signature fields here with no validation or value.
        newPatientForm.addControl('signaturePatient', new FormControl<Resource | null>(null));
        newPatientForm.addControl('signaturePatientId', new FormControl<number | null>(null));

        this.patientsArray.push(newPatientForm as any);
        this.enableIdStateManagementForGroup(newPatientForm, this.patientsArray.length - 1);
    }

    /**
     * Deletes the patient at the specified index.
     *
     * @param {number} idx The index of the patient to delete.
     */
    public async deletePatient(idx: number, patientForm: FormControl<BasePatientDetailsFormFields | null>): Promise<void> {

        // Index will be different depending if the customer is a patient.
        const correctIndex = this.isCustomerAPatient ? idx : idx + 1;

        // If there is a patientID, the patient has been saved on the server.
        const patientId = patientForm.get('id')?.value;

        // Handle if the patient has not been saved on the server.
        if (!patientId) {
            if (correctIndex >= 0 && await this.asyncConfirm('Delete patient?', 'Patient data will be erased.')) {
                this.deletePatientFormAtIndex(correctIndex);
            }
            else this.matSnackbar.open('Something went wrong; Could not delete patient.', 'Close', { duration: 3000 });
        }
        // Handle if the patient has been saved on the server.
        else if (await this.asyncConfirm('Delete patient?', 'Patient data will be erased.')) {
            this.showPatientLoader = true;
            firstValueFrom(this.apiService.deletePatient(patientId))
                .then(() => {
                    this.deletePatientFormAtIndex(idx);
                    this.showPatientLoader = false;
                })
                .catch((error: any) => {
                    console.error('Failed to delete patient.', error);
                    this.matSnackbar.open('Failed to delete patient.', 'Close', { duration: 3000 });
                    this.showPatientLoader = false;
                });
        }
    }

    private deletePatientFormAtIndex(index: number) {
        this.patientsArray.removeAt(index);
        this.removeIdStateSubscriptionAtIndex(index);
        this.reinstantiateIdStateSubscriptions();
    }

    /**
     * Toggles the patient form to be the same as the customer form.
     *
     * @param {MatSlideToggleChange} event The event containing the checked status.
     */
    public onTogglePatientSameAsCustomer(event: MatSlideToggleChange) {
        this.isCustomerAPatient = event.checked;
        this.updateCustomerTypeFlag();
    }

    public async onToggleAccountHolderSameAsCustomer(event: MatSlideToggleChange) {
        const accountHolderId = this.bankForm.controls['accountHolderEntityId']?.value;
        const customerId = this.form.controls['debtorCustomerId']?.value;

        // Path A: toggling ON ("same as customer") with an existing distinct account holder on
        // record → confirm, then delete via the serialized queue. Local form state is *not*
        // mutated here; that happens only after the delete confirms on `deleted$`.
        if (event.checked === true && accountHolderId !== null && accountHolderId !== undefined && accountHolderId !== customerId) {
            const confirmed = await this.asyncConfirm('Remove account holder?', 'The customer will become the default account holder.');
            if (!confirmed) {
                this.revertToggle(event);
                return;
            }

            this.showAccountHolderLoader = true;
            this.saveService.requestDelete({
                patientId: accountHolderId,
                context: { kind: 'accountHolder', toggleSource: event.source } as AccountHolderDeleteContext,
            });
            return;
        }

        // Path B: toggling OFF, or toggling ON when no distinct holder exists yet. Pure local
        // form mutation; no backend delete needed.
        this.applyAccountHolderToggleState(event.checked);
    }

    /**
     * Local state transition for the account-holder toggle. Extracted so both the "no backend
     * delete needed" path and the post-delete handler can share the same validator/clear logic.
     */
    private applyAccountHolderToggleState(isSameAsCustomer: boolean): void {
        this.isCustomerTheAccountHolder = isSameAsCustomer;
        this.updateCustomerTypeFlag();

        if (!isSameAsCustomer) {
            this.bankForm.controls['accountHolderFirstName'].setValidators([Validators.required, Validators.minLength(2)]);
            this.bankForm.controls['accountHolderLastName'].setValidators([Validators.required, Validators.minLength(2)]);
            this.bankForm.controls['accountHolderIdentityType'].setValidators([Validators.required, Validators.min(1)]);
            this.bankForm.controls['accountHolderIdentityNumber'].setValidators([Validators.required, isRSAIdentity('accountHolderIdentityType')]);
        } else {
            this.bankForm.controls['accountHolderFirstName'].setValidators(null);
            this.bankForm.controls['accountHolderLastName'].setValidators(null);
            this.bankForm.controls['accountHolderIdentityType'].setValidators(null);
            this.bankForm.controls['accountHolderIdentityNumber'].setValidators(null);
            this.bankForm.controls['accountHolderFirstName'].reset(null);
            this.bankForm.controls['accountHolderLastName'].reset(null);
            this.bankForm.controls['accountHolderIdentityType'].reset(null);
            this.bankForm.controls['accountHolderIdentityNumber'].reset(null);
        }

        this.bankForm.updateValueAndValidity();
        this.bankForm.controls['accountHolderFirstName'].updateValueAndValidity();
        this.bankForm.controls['accountHolderLastName'].updateValueAndValidity();
        this.bankForm.controls['accountHolderIdentityType'].updateValueAndValidity();
        this.bankForm.controls['accountHolderIdentityNumber'].updateValueAndValidity();
    }

    /**
     * Revert a MatSlideToggle to its pre-change state. Use when a confirmation is declined or a
     * dependent backend operation fails — the user's intent did not take effect, so the visual
     * must match.
     */
    private revertToggle(event: MatSlideToggleChange): void {
        event.source.checked = !event.checked;
    }

    /**
     * Strips the Authorizer bit (4) from any composite customerType across the patient stepper
     * and drops any entry whose id matches the deleted account holder. Independent of
     * `findPatientFormIndexByPatientId` so cleanup is deterministic even if customerType has
     * drifted.
     */
    private cleanupAuthorizerStateAfterDelete(deletedPatientId: number): void {
        for (let i = this.patientsArray.controls.length - 1; i >= 0; i--) {
            const ctrl = this.patientsArray.controls[i];
            const id = ctrl.get('id')?.value;
            const type = ctrl.get('customerType')?.value as CustomerType | null;
            if (id === deletedPatientId) {
                this.deletePatientFormAtIndex(i);
                continue;
            }
            if (type !== null && type !== undefined && (type & CustomerType.Authorizer)) {
                ctrl.get('customerType')?.setValue((type & ~CustomerType.Authorizer) as CustomerType, { emitEvent: false });
            }
        }
    }

    private subscribeToDeleteResults(): void {
        this.saveService.deleted$
            .pipe(takeUntil(this.destroyed$))
            .subscribe(result => {
                const ctx = result.request.context as AccountHolderDeleteContext | undefined;
                if (!ctx || ctx.kind !== 'accountHolder') return;

                this.showAccountHolderLoader = false;

                if (!result.ok) {
                    this.matSnackbar.open('Failed to delete account holder.', 'Close', { duration: 3000 });
                    // Revert the toggle — user's intent did not take effect.
                    if (ctx.toggleSource) ctx.toggleSource.checked = false;
                    return;
                }

                this.matSnackbar.open('Previous account holder deleted.', 'Close', { duration: 3000 });

                // Clear holder identity fields and the entity id.
                this.bankForm.controls['accountHolderEntityId'].setValue(null, { emitEvent: false });
                this.bankForm.controls['accountHolderFirstName'].reset(null);
                this.bankForm.controls['accountHolderLastName'].reset(null);
                this.bankForm.controls['accountHolderIdentityType'].reset(null);
                this.bankForm.controls['accountHolderIdentityNumber'].reset(null);

                // Defensive: strip Authorizer bit across all patients and drop any entry whose id
                // matches the deleted holder, regardless of customerType.
                this.cleanupAuthorizerStateAfterDelete(result.request.patientId);

                // Now commit the toggle's intent locally — this also updates customerType for the
                // primary debtor via updateCustomerTypeFlag().
                this.applyAccountHolderToggleState(true);

                this.bankForm.controls['accountHolderIdentityType'].updateValueAndValidity();
            });
    }

    private updateCustomerTypeFlag(): void {
        const getCustomerType = () => {
            if (this.isCustomerAPatient && this.isCustomerTheAccountHolder) {
                return CustomerType.PatientDebtorAndAuthorizer;
            } else if (this.isCustomerAPatient && !this.isCustomerTheAccountHolder) {
                return CustomerType.PatientAndDebtor;
            } else if (!this.isCustomerAPatient && this.isCustomerTheAccountHolder) {
                return CustomerType.DebtorAndAuthorizer;
            } else {
                return CustomerType.Debtor;
            }
        };

        this.customerForm.controls['customerType'].setValue(getCustomerType());
    }

    /**
     * Saves the applications and then closes it.
     * Should the save fail, the dialog won't close.
     */
    public saveAndClose(): void {
        // Ignore repeat clicks: each queued save would insert its own copy of any new misc document.
        if (this.isClosing) {
            return;
        }

        this.isClosing = true;

        this.saveApplication(true);
    }

    /**
     * Close the dialog without issuing a save or confirmation.
     */
    public async closeWithoutSaving(confirmClose = true): Promise<void> {
        // TODO replace with dialog confirmation with save / discard options.
        if (!confirmClose || confirmClose && (this.isReadMode || await this.asyncConfirm('Close without saving?', 'Unsaved changes will be lost.'))) {
            // Wait for any in-flight or queued save to complete before tearing down. The service
            // is providedIn: 'root' so the HTTP itself would survive destruction, but flushing
            // here prevents stale form state being read after the dialog closes.
            await this.saveService.flush();
            this.destroyed$.next();
            setTimeout(() => {
                this.dialogRef.close();
            });
        }
    }

    public confirmCloseIfDirty(): void {
        if (!this.isReadMode && this.form.dirty) {

            // // log out each form control's name and dirty state.
            // Object.keys(this.form.controls).forEach(key => {
            //     if (this.form.get(key)?.dirty) {
            //         console.log('2) form.' + key, this.form.get(key)?.dirty);
            //         // Log each control on the form key.
            //         const controls = (<any>this.form.get(key))?.controls || [];
            //         Object.keys(controls).forEach(subKey => {
            //             if (this.form.get(key)?.get(subKey)?.dirty)
            //                 console.log('2) form.' + key + '.' + subKey, this.form.get(key)?.get(subKey)?.dirty);
            //         });
            //     }
            // });

            this.closeWithoutSaving();
        } else {
            this.closeWithoutSaving(false);
        }
    }

    public markFormAtStepTouched() {
        // If the dialog is not in readMode, find the current step and mark all as touched.
        if (!this.isReadMode) {
            this.formAtIndex()?.markAllAsTouched();

            // If the step is the signing step, mark the fields as dirty as well.
            if (this.currentStep === 6) {
                this.markSignaturesDirty();
            }
        }
    }

    public changeAgent() {
        const dialogRef = this.dialog.open(SelectVendorAgentDialog, {
            data: { vendorAgents: this.config.vendor?.agents || [] }
        });

        dialogRef.afterClosed()
            .subscribe((result) => {
                if (result?.agentId !== null && result?.agentId !== undefined) {
                    this.form.controls['agent'].setValue(result.agentId);
                    const agent = this.config.vendor?.agents.find(a => a.id === result.agentId);
                    if (agent) {
                        this.agentName = agent.firstName + ' ' + agent.lastName;
                    }
                }

            });
    }

    public stepOnInvalidForm() {
        this.markFormAtStepTouched();
        // this.matSnackbar.open('Missing fields must be filled in before submission.', 'Close', { duration: 3000 });
        this.useFormStepperBypass = true;
        setTimeout(() => {
            this.stepper.next();
            setTimeout(() => {
                this.useFormStepperBypass = false;
            });
        });

    }

    public onSigningPageBack(): void {
        this.signingMethod = SigningMethod.None;
    }

    public downloadSigningDocuments() {
        const applicationId = this.form.get('id')?.value;

        if (!applicationId) {
            this.matSnackbar.open('Application not saved.', 'Close', { duration: 3000 });
        } else {

            this.dialog.open(ViewPrintEmailDialog, {
                data: {
                    type: TableDatumType.VendorApplication,
                    documentType: DocumentTypeEnum.SigningDocuments,
                    customerProduct: undefined,
                    vendorApplication: { id: applicationId, reference: this.form.value.reference },
                    autoAction: 'download',
                }
            });
        }
    }

    public onUploadManualSignedDocument(event: any) {
        // Rename each file to “Signed Quotation and Agreement”.
        const fileNameFn = (file: File) => 'Signed Quotation and Agreement.pdf';

        // Read file into local object.
        this.fileService.loadFilesFromEventToLocalArray(event.target.files, [], fileNameFn)
            .then((updatedFileList) => {
                // Trigger upload for the new file,
                // And upload the file to the server.
                this.fileService.uploadFileToServer(updatedFileList[0])
                    .then((updatedFile) => {
                        if (updatedFile.resource?.id) {

                            this.form.controls['files'].controls['loanAgreementId'].setValue(updatedFile.resource.id);
                            this.form.controls['files'].controls['loanAgreement'].setValue(updatedFile.resource);

                            this.loanAgreementModel.set({
                                // E.g: 1738747871524-Signed-Quotation-and-Agreement -> Signed Quotation and Agreement
                                filename: updatedFile.resource.name?.replace(/-/g, ' ').replace(/\d+/g, '') || '',
                                size: formatBytes(updatedFile.resource.size),
                                contentUrl: updatedFile.resource.contentUrl
                            });

                            // The signing step's Next button gates on this validity,
                            // which is otherwise only computed on load and when the
                            // signing method is chosen (i.e. before the upload).
                            this.updateManualSigningValidationStatus();

                            // Save the newly set file ID.
                            this.saveApplication();
                        } else {
                            this.matSnackbar.open('Failed to upload file to server. Please try again later.', 'Close', { duration: 3000 });
                        }

                    })
                    .catch((ex) => {
                        console.error('Failed to upload file to server.', ex);
                        this.matSnackbar.open('Failed to upload file to server.', 'Close', { duration: 3000 });
                    });
            })
            .catch(() => {
                this.matSnackbar.open('Could not select one of the files. Please try again', 'Dismiss', { duration: 5000 });
            });
    }

    //#endregion
    //#region Events and Domain Functions
    // $watches/$on events, functions which don't fall into any of the other regions,
    // including any function that has to do domain functionality.

    /**
     * Changes focus to the specified element and adds a CSS animation to it.
     * The animation will blink over 700ms and then be removed via a setTimeout.
     *
     * @param {(HTMLElement | string | AbstractControl)} elementRef The element (or the `name` of it) to focus on.
     * @example
     * ```html
     * <mat-form-field> <!-- <= This is the parent and will be animated. -->
     *       <mat-label>ID Type</mat-label>
     *       <mat-select formControlName="identityType" (selectionChange)="changeFocusToAndAnimation(patientIdInput);">
     *           ...
     *       </mat-select>
     *   </mat-form-field>
     * 
     *   <mat-form-field>
     *       <mat-label>ID Field</mat-label>
     *       <input matInput formControlName="identityNumber" #patientIdInput> <!-- <= This element will be focused. -->
     *   </mat-form-field>
     * ```
     * @memberof CaptureDialog
     */
    public changeFocusToAndAnimation(elementRef: HTMLElement | string | AbstractControl) {

        // Store as function to use in either case.
        const focusAndFlash = (element: HTMLElement) => {
            // Settimeout to ensure the element is focused after angular has detected changes.
            setTimeout(() => {
                element.focus();

                // If element is a mat-select, open the dropdown.
                if (element.tagName.toUpperCase() === 'MAT-SELECT') {
                    element.click();
                }
            });

            // Find the mat-form-field parent element and add the form-blink-animation class to it.
            const matFormField = element.closest('mat-form-field');

            if (matFormField) {
                matFormField.classList.add('form-blink-animation');
                setTimeout(() => {
                    matFormField.classList.remove('form-blink-animation');
                }, 800); // Animation is 700ms, so 800ms should be enough.
            }
        };

        // Use element or try find by name.
        if (elementRef && elementRef instanceof HTMLElement)
            focusAndFlash(elementRef);
        else if (typeof elementRef === 'string') {
            setTimeout(() => {
                const element = document.getElementsByName(elementRef)[0];
                if (element) focusAndFlash(element);
            });
        }
    }

    /**
     * Enables monitoring of the form changes and auto-saves the form.
     */
    private enableAutoSaves(): void {
        const skipNoneQualifier = () => false;
        const skipIfNotOnBankStepQualifier = () => this.currentStep !== 3;
        // Save on valid customer ID:
        this.enableAutoSaveForControls(skipNoneQualifier, this.customerForm.get('identityNumber'));
        // Save on valid patient form details:
        this.enableAutoSaveForForm(this.employmentForm, skipNoneQualifier, 'employmentForm');
        this.enableAutoSaveForForm(this.patientStepperForm, skipNoneQualifier, 'patientStepperForm');
        this.enableAutoSaveForForm(this.bankForm, skipIfNotOnBankStepQualifier, 'bankForm');
        this.enableAutoSaveForForm(this.loanForm, skipNoneQualifier, 'loanForm');
        this.enableAutoSaveForForm(this.form.get('files') as FormGroup<FileFormFields>, skipNoneQualifier, 'files');
    }

    /**
     * Subscribes to the form changes and enables auto-save for the form.
     * Also, enables/disables certain fields based on the values of other fields.
     */
    private subscribeToFormChanges(): void {
        // Enable/disable pay date based on pay cycle.
        this.enablePayCycleAndPayDateValidators();
        // Enable/disable ID field based on ID type.
        this.enableIdStateManagementForGroup(this.customerForm, -2);

        // Sync customer info and patient info if the customer is also a patient.
        this.enableAutoSyncValuesForCustomerAndPatient0();

        // if (this.isNewApplication) {
        if (this.isCustomerAPatient) {
            this.disablePatient0();
        }

        // Call setStartDateOptions when PayCycleId and Payday are set.
        const payCycle = this.employmentForm.get('payCycleId');
        const payDay = this.employmentForm.get('payDay');
        if (payCycle && payDay) {
            combineLatest([payCycle.valueChanges, payDay.valueChanges])
                .pipe(takeUntil(this.destroyed$))
                .subscribe(() => {
                    this.setStartDateOptions();
                    // Reset the loan start date.
                    this.loanForm.controls['startDate'].setValue(null);
                });
        }

        this.monitorCalculatedFields();

        // Enables the step validation form for the patients array.
        this.enablePatientsFormValidation();

        this.enableSubmissionValidator();
    }

    private monitorCalculatedFields() {
        this.loanForm.valueChanges
            .pipe(
                filter(() => this.loanForm.status === 'VALID'),
                debounceTime(300), // Keystroke debounce.
                takeUntil(this.destroyed$)
            )
            .subscribe(() => {
                this.calculateInstalment$.next();
            });
    }

    /**
     * This method monitors the states of all the different forms and enables/disables the submission button based on the state of the form.
     * All forms must have data, al files must be uploaded and saved on the form(s).
     * 
     * Customer form must be valid. There will always be at least one patient and that is the customer themselves.
     * If the customer is not the patient, then there must be at least 2 patients.
     * If the customer is not the account holder, the account holder details must be valid.
     * Employment form must be valid.
     * Loan form must be valid.
     * Bank form must be valid and have passed the API validation.
     * File form must be valid and all required files must be uploaded.
     * Signature form must be valid and all required signatures must be uploaded, as well as each required agreement checked.
     * User must agree to the review.
     * 
     */
    private enableSubmissionValidator() {
        combineLatest([
            this.form.valueChanges.pipe(startWith(this.form.value)),
            this.patientStepperForm.valueChanges.pipe(startWith(this.patientStepperForm.value)),
            this.fileStepperForm.valueChanges.pipe(startWith(this.fileStepperForm.value)),
            this.signatureStepperFrom.valueChanges.pipe(startWith(this.signatureStepperFrom.value))
        ])
            .pipe(
                takeUntil(this.destroyed$),
                debounceTime(500)
            )
            .subscribe(() => {
                const form = this.form;
                const patients = this.patientStepperForm;
                const files = this.fileStepperForm;
                const signatures = this.signatureStepperFrom;

                const allPatientsValid = patients.get('allPatients')?.value;
                const allFilesValid = files.get('allFiles')?.value;
                const allSignaturesValid = signatures.get('allSignatures')?.value;

                const disabled = form.disabled || form.invalid || !allFilesValid || !allSignaturesValid || !allPatientsValid;

                this.maySubmit = !disabled;
            });
    }

    /**
     * The callback for when the user selects a bank.
     *
     * @param {MatSelectChange} event The event containing the selected bank.
     */
    public onBankChange(event: MatSelectChange) {
        // Automatically set the branch code based on the selected bank.
        const bankId = event.value;
        const branchCode = this.bankForm.get('branchCode');
        branchCode?.setValue(this.bankOptions.find(b => b.id === bankId)?.code || '');
        this.onAccountNumberKeyUp();
    }

    /**
     * The callback for when the user steps through the stepper.
     *
     * @param {number} newIndex the index of the new step.
     */
    public onStep(newIndex: number) {
        const previousStep = this.currentStep + 0;

        const formAtStep = this.formAtIndex(previousStep);
        if (!this.isReadMode && formAtStep?.valid && formAtStep?.dirty) {
            this.saveApplication();
        } else if (!this.isReadMode && formAtStep?.invalid) {
            this.matSnackbar.open('Please complete the current step before proceeding.', 'OK', { duration: 3000 });
        }

        this.currentStep = newIndex;

        if (this.currentStep === 7) {
            this.setReviewModel();
        }
    }

    /**
     * When the user enters invalid banking details, all the form inputs are marked with an error.
     * However, mat-select don't register new changes and require selecting a new bank.
     * We don't want to do that.
     * This method will remove the error from the mat-select and allow the user to proceed.
     */
    public removePleaseCheckValidator(): void {

        if (this.bankForm.get('bankId')?.errors?.['pleaseCheck']) {
            this.bankForm.get('bankId')?.setErrors(null);
            this.bankForm.get('bankId')?.updateValueAndValidity();
        }

    }

    /**
     * Nedcor/Nedbank is the only bank that is specific about whether we select Current or Savings account.
     * When an account starts with "1" it is a Current Acc and "2" Savings Acc. 
     * This is regardless of what the patient thinks their account is.
     * 
     * We'll disable changing the account type when the account number starts with "1" or "2" for Nedbank/Nedcor.
     */
    public onAccountNumberKeyUp() {
        if (this.isReadMode) return;

        this.removePleaseCheckValidator();

        const bankId = this.bankForm.get('bankId')?.value;
        const accountNumber = this.bankForm.get('bankAccountNumber')?.value;
        const nedBank = this.bankOptions.find(b => b.name.includes('Nedcor') || b.name.includes('Nedbank'));

        if (accountNumber && (accountNumber.startsWith('1') || accountNumber.startsWith('2'))
            && nedBank
            && nedBank.id === bankId
        ) {
            this.bankForm.get('bankAccountType')?.setValue(
                accountNumber.startsWith('1') ? BankAccountType.Current : BankAccountType.Savings);
            this.bankForm.get('bankAccountType')?.disable();
        }

        else this.bankForm.get('bankAccountType')?.enable();
    }

    //#endregion
    //#region Data Access & Subscriptions
    // API interactions, NGRX selects, etc.

    /**
     * Fetches the bank options from the server.
     * Sets the bankOptions.
     */
    private fetchBankOptions(): void {
        this.apiService.listBanks()
            .subscribe(banks => {
                this.bankOptions = banks || StaticBankList;
            });
    }

    /**
     * Unsubscribes from the stateManagement sub for the provided index.
     * Then, deletes the memory reference.
     *
     * @see idStateSubscriptions for more information.
     */
    private removeIdStateSubscriptionAtIndex(idx: number) {
        const sub = this.idStateSubscriptions[idx + ''];
        if (sub !== undefined) {
            sub.unsubscribe();
            setTimeout(() => {
                delete this.idStateSubscriptions[idx + ''];
            });
        }
    }

    /**
     * Recalculates the indexes of each subscription by removing all existing ones
     * and creating new ones for the current state of the patients array.
     *
     * @see idStateSubscriptions for more information.
     */
    private reinstantiateIdStateSubscriptions(): void {
        // Remove each subscription.
        this.patientsArray.controls.forEach((c, index) => {
            this.removeIdStateSubscriptionAtIndex(index);
        });

        // Re-enable the subscriptions.
        setTimeout(() => {
            this.patientsArray.controls.forEach((control, index) => {
                this.enableIdStateManagementForGroup(control as any, index, true);
            });
        });
    }

    /**
     * Enqueues a save through CaptureSaveService. The payload is built *inside* the queue's
     * concatMap (not here) so a queued save always reads the latest form state — including ids
     * written by previous responses — preventing the duplicate-application race.
     */
    private saveApplication(closeAfterSave = false, message?: string): void {
        if (this.config.readMode) {
            this.matSnackbar.open('This application cannot be saved.', 'Close', { duration: 5000 });
            return;
        }

        this.saveService.requestSave({
            buildPayload: () => this.toVendorApplication() as VendorApplication,
            closeAfterSave,
            // Stash the snackbar message on the request so the result subscription can display it.
            // (Plain object property — TS will allow extra fields on this structural type.)
            ...(message !== undefined ? { message } as any : {}),
        });
    }

    /**
     * Single subscription to CaptureSaveService.saved$ — owns all response-side form mutation.
     * Replaces the per-call .subscribe() that used to live inside saveApplication(), so even
     * concurrent autosave triggers collapse to one ordered stream of writes here.
     */
    private subscribeToSaveResults(): void {
        this.saveService.saved$
            .pipe(takeUntil(this.destroyed$))
            .subscribe(result => {
                const closeAfterSave = !!result.request.closeAfterSave;
                const message = (result.request as any).message as string | undefined;
                const resp = result.response;

                if (result.error) {
                    if (closeAfterSave) {
                        this.isClosing = false;
                        this.matSnackbar.open('Failed to save the application. Please try again.', 'Close', { duration: 3000 });
                    }
                    return;
                }

                this.showSaveMessage(closeAfterSave ? 'Application saved. Closing...' : message);

                if (!resp) {
                    if (closeAfterSave) {
                        this.dialogRef.close();
                    }

                    return;
                }

                // Set IDs, reference and other data.
                this.form.controls['reference'].setValue(resp.reference);
                this.form.controls['id'].setValue(resp.id);
                this.form.controls['debtorCustomerId'].setValue(resp.debtorCustomerId);
                this.isNewApplication = false;

                // Update the patient IDs.
                this.patientsArray.controls.forEach((control, index) => {
                    control.get('vendorApplicationId')?.setValue(resp.id, { emitEvent: false });
                    const correspondingPatient = resp.patients.find(p => p.identityNumber === control.get('identityNumber')?.value && p.customerType === control.get('customerType')?.value) || resp.patients[index];
                    control.get('id')?.setValue(correspondingPatient.id, { emitEvent: false });

                    // Patch server-assigned join-row ids back into vendorApplicationCustomerResources.
                    // Without this, every subsequent auto-save would re-send entries with id=null and
                    // the backend would insert another duplicate row each time.
                    const resourcesCtrl = control.get('vendorApplicationCustomerResources');
                    const localResources = (resourcesCtrl?.value ?? []) as VendorApplicationCustomerResource[];
                    if (resourcesCtrl && localResources.length) {
                        // The search/load response names the join rows `resources`, but the
                        // save response serialises the EF entity graph, where the collection
                        // is `vendorApplicationCustomerResources` — read both, or save
                        // responses reconcile against an empty array and every save
                        // re-inserts the id=null rows as duplicates.
                        const serverResources = ((correspondingPatient as any).resources
                            ?? (correspondingPatient as any).vendorApplicationCustomerResources
                            ?? []) as VendorApplicationCustomerResource[];
                        const byResourceId = new Map<number, VendorApplicationCustomerResource>();
                        serverResources.forEach(r => { if (r.resourceId != null) byResourceId.set(r.resourceId, r); });
                        const reconciled = localResources
                            .map(r => {
                                const match = r.resourceId != null ? byResourceId.get(r.resourceId) : undefined;
                                return match ? { ...r, id: match.id, vendorApplicationCustomerId: match.vendorApplicationCustomerId } : r;
                            })
                            .reduce<VendorApplicationCustomerResource[]>((acc, r) => {
                                const existingIdx = acc.findIndex(x => x.resourceId === r.resourceId);
                                if (existingIdx === -1) acc.push(r);
                                else if (acc[existingIdx].id == null && r.id != null) acc[existingIdx] = r;
                                return acc;
                            }, []);
                        resourcesCtrl.setValue(reconciled as any, { emitEvent: false });

                        // Patient 0 mirrors customerInformation via the auto-sync,
                        // which copies vendorApplicationCustomerResources wholesale.
                        // Reconcile the customerInformation copy too, or its stale
                        // id=null rows overwrite patient 0 on the next sync and every
                        // save re-inserts them server-side as duplicates.
                        if (index === 0) {
                            this.customerForm.get('vendorApplicationCustomerResources')
                                ?.setValue(reconciled as any, { emitEvent: false });
                        }
                    }
                });

                // Update account holder ID if enabled.
                if (!this.isCustomerTheAccountHolder && resp.bankAccountCustomerId) {
                    const currentHolderId = this.bankForm.controls['accountHolderEntityId'].value;
                    if (currentHolderId !== resp.bankAccountCustomerId) {
                        this.bankForm.controls['accountHolderEntityId'].setValue(resp.bankAccountCustomerId, { emitEvent: false });
                    }
                }

                // Close only after the server ids are patched in: a save still queued behind this one
                // builds its payload from these forms, and would re-insert id=null rows otherwise.
                if (closeAfterSave) {
                    this.dialogRef.close();
                    return;
                }

                // Mark forms as pristine after the current microtask so child controls finish settling.
                setTimeout(() => {
                    this.markFormsAsPristine();
                    if (this.calculateAfterSave) {
                        this.calculateAfterSave = false;
                        this.calculateInstalment$.next();
                    }
                });
            });
    }

    /**
     * The instalment is calculated on the server-side.
     * This subscription fires off a GET request to get the loan and set it on the form for the user to see.
     */
    private subscribeToUpdateInstalment() {
        this.calculateInstalment$
            .pipe(
                debounceTime(300),
                filter(() => {
                    // Set this flag to issue a publish onto this stream when the save is complete.
                    this.calculateAfterSave = this.isSaving; // Doing it in the filter to prevent an additional stream and maintain same scope.
                    return !this.isSaving;
                }),
                switchMap(() => {
                    const id = this.form.get('id')?.value;
                    this.showLoanLoader = true;

                    if (id !== null && id !== undefined)
                        return this.apiService.calculateLoanAmount(id);

                    else return of(null);

                }),
                catchError((error) => {
                    console.error('Failed to calculate loan amount.', error);
                    // Show toast if they're on the loan step.
                    this.showLoanLoader = false;

                    if (this.currentStep === 4) this.matSnackbar.open('Could not calculate instalment. Please try again later.', 'Close', { duration: 3000 });

                    this.loanForm.controls['instalment'].setValue(null, { emitEvent: false });
                    this.loanForm.controls['instalment'].setValue(null, { emitEvent: false });

                    return of(null);
                }),
                takeUntil(this.destroyed$)
            )
            .subscribe((totalAmount => {
                this.showLoanLoader = false;
                if (totalAmount === null || totalAmount === undefined) {
                    this.loanForm.controls['instalment'].setValue(null, { emitEvent: false });
                } else {
                    const installments = this.loanForm.get('instalments')?.value || 0;
                    this.loanForm.controls['instalment'].setValue(totalAmount / installments, { emitEvent: false });
                }
            }));
    }

    //#endregion
    //#region Setters, Updaters and Preloaders
    // Setter functions, and methods called from the Instantiation region.

    /**
     * Loads the provided data into the form.
     *
     * @param {Partial<VendorApplication>} application The data to load into the form. Partial as it may be only partially complete.
     */
    private loadConfigDataIntoForm() {
        // console.log('loadConfigDataIntoForm > config:', this.config)
        let saveAfterLoan = false;
        // Patch the form with the data coming in.
        const application: Partial<VendorApplication> = this.config.application || {};
        if (!application) return;

        // Find the customer in the patients array and patch the customer form.
        let customer = application.patients?.find(p => p.id === application.debtorCustomerId);
        if (!customer) {
            // Find customer by customer Type.
            customer = application.patients?.find(p => p.customerType === CustomerType.Debtor || p.customerType === CustomerType.DebtorAndAuthorizer || p.customerType === CustomerType.PatientDebtorAndAuthorizer);
        }

        this.addPatient(); // Customer Patient.

        if (customer) {
            // Determine if the customer is also a patient.
            if (customer.customerType === CustomerType.PatientDebtorAndAuthorizer || customer.customerType === CustomerType.PatientAndDebtor) {
                this.onTogglePatientSameAsCustomer({ checked: true, source: null as any });
            }

            this.customerForm.patchValue({
                id: customer.id,
                address: customer.address,
                customerType: customer.customerType,
                email: customer.email,
                firstName: customer.firstName,
                identityNumber: customer.identityNumber,
                identityType: customer.identityType,
                lastName: customer.lastName,
                maritalStatus: customer.maritalStatus,
                mobileNumber: customer.mobileNumber,
                postalCode: customer.postalCode,
                title: customer.title,
                photoIDBookId: customer.photoIDBookId,
                photoIDBook: customer.photoIDBook,
                photoPatientCardId: customer.photoPatientCardId,
                photoPatientCard: customer.photoPatientCard,
                photoLabOrderId: customer.photoLabOrderId,
                photoLabOrder: customer.photoLabOrder,
                signaturePatientId: customer.signaturePatientId,
                signaturePatient: customer.signaturePatient,
                vendorApplicationCustomerResources: toMiscResources((<any>customer).resources),
                // vendorApplicationCustomerResources: customer.vendorApplicationCustomerResources,
                vendorApplicationId: customer.vendorApplicationId,
            });

            setTimeout(() => {
                // set the ID again since the state management will clear it.
                this.customerForm.get('identityNumber')?.setValue(customer?.identityNumber || null);
            });
        }

        // Patch the patients array with the data.
        // First patch the customer/debtor as they should always be patient 0.
        if (customer) {
            this.patientsArray.clear();
            this.patientsArray.push(this.newPersonalDetailsForm(customer.customerType, customer) as any);
        }

        this.isCustomerTheAccountHolder = customer?.customerType === CustomerType.PatientDebtorAndAuthorizer || customer?.customerType === CustomerType.DebtorAndAuthorizer;
        const accountHolder = this.isCustomerTheAccountHolder ? undefined : application.patients?.find(p => p.id === application.bankAccountCustomerId);

        // Then patch the rest of the patients.
        application.patients?.forEach(patient => {
            // if (patient.id !== application.debtorCustomerId && patient.customerType !== CustomerType.Authorizer) {
            if (patient.id !== customer?.id && patient.customerType !== CustomerType.Authorizer) {
                this.patientsArray.push(this.newPersonalDetailsForm(patient.customerType, patient) as any);
            }
        });

        // Patch the employment form.
        this.employmentForm.patchValue({
            designation: application.designation || null,
            employeeNumber: application.employeeNumber || null,
            employer: application.employer || null,
            employerAddress: application.employerAddress || null,
            employerBranch: application.employerBranch || null,
            employerTelephone: application.employerTelephone || null,
            employerPostalCode: application.employerPostalCode || null,
            employmentStartDate: application.employmentStartDate || null,
            payCycleId: application.payCycleId || null,
            payDay: application.payDay || null,
        });
        // First - Let the forms update.
        setTimeout(() => {
            this.employmentForm.get('payCycleId')?.setValue(application.payCycleId || null);

            setTimeout(() => { // Second - Let the payCycleId update and load the payDay options.
                this.employmentForm.get('payDay')?.setValue(application.payDay as any);

                // Only run this if we are not in read mode.
                if (!this.config.readMode) {
                    setTimeout(() => { // Thrid - Let the payDay update the loan start date options, and load the start date options.
                        const loanStartDate = dayjs(application.startDate || new Date());
                        const nearestOption = this.loanStartDateOptions.find(o => {
                            return loanStartDate.isBetween(dayjs(o.value).startOf('month'), dayjs(o.value).endOf('month'), null, '[]');
                        }) || this.loanStartDateOptions[0];

                        this.loanForm.get('startDate')?.setValue(nearestOption?.value || null);
                    });
                }
            });
        });

        // Set the start date options based on the pay cycle and pay day.
        this.setStartDateOptions();

        // Find branch code from list of banks.
        const branchCode = this.bankOptions.find(b => b.id === application.bankId)?.code || null;

        // Patch the bank details form.
        this.bankForm.patchValue({
            bankId: application.bankId || null,
            branchCode: branchCode,
            bankAccountType: application.bankAccountType || null,
            bankAccountNumber: application.bankAccountNumber || null,

            // Account holder details.
            accountHolderFirstName: accountHolder?.firstName || null,
            accountHolderLastName: accountHolder?.lastName || null,
            accountHolderIdentityType: accountHolder?.identityType || null,
            accountHolderIdentityNumber: accountHolder?.identityNumber || null,
            accountHolderEntityId: accountHolder?.id || null,
        });

        // Patch the loan form.
        this.loanForm.patchValue({
            loanAmount: application.loanAmount || null,
            initiationFee: application.initiationFee || null,
            administrationFee: application.administrationFee || null,
            startDate: application.startDate || null,
            instalment: application.instalment || null,
            instalments: application.instalments || null,
        });

        // When the application is still editable, update the admin and initiation fee on each open.
        if (this.config.readMode === false && this.config.vendor) {
            this.loanForm.controls['initiationFee']?.setValue(this.config.vendor.initiationFee);
            this.loanForm.controls['administrationFee']?.setValue(this.config.vendor.administrationFee);

            // If either fee have changed, update/save the new application.
            if (this.config.application?.administrationFee !== this.config.vendor.administrationFee || this.config.application.initiationFee !== this.config.vendor.initiationFee) {
                saveAfterLoan = true;
            }
        }

        // Patch the signature form.
        this.signatureForm?.patchValue({
            agreeFirstInstalment: application.agreeFirstInstalment !== undefined ? application.agreeFirstInstalment : null,
            agreeMandate: application.agreeMandate !== undefined ? application.agreeMandate : null,
            agreeMarketing: application.agreeMarketing !== undefined ? application.agreeMarketing : null,
            agreeTermsSpecsfin: application.agreeTermsSpecsfin !== undefined ? application.agreeTermsSpecsfin : null,
            notUnderReview: application.notUnderReview !== undefined ? application.notUnderReview : null,
            signatureMandate: application.signatureMandate || null,
            signatureMandateId: application.signatureMandateId || null,
            signatureQuotation: application.signatureQuotation || null,
            signatureQuotationId: application.signatureQuotationId || null,
            signatureTerms: application.signatureTerms || null,
            signatureTermsId: application.signatureTermsId || null,
        });

        if (application.vendorAgentId !== null && application.vendorAgentId !== undefined) {
            const agent = this.config.vendor?.agents?.find(agent => agent.id === application.vendorAgentId);
            if (agent) {
                this.agentName = agent.firstName + ' ' + agent.lastName;
            }
        }

        // Patch the reference number and ID.
        this.form.get('reference')?.setValue(application.reference || null);
        this.form.get('id')?.setValue(application.id || null);
        this.form.get('debtorCustomerId')?.setValue(application.debtorCustomerId || null);
        this.form.get('bankAccountCustomerId')?.setValue(application.bankAccountCustomerId || null);

        // Patch the vendor and agent.
        this.form.get('vendor')?.setValue(application.vendorId || null);
        this.form.get('agent')?.setValue(application.vendorAgentId || null);

        // Patch the files form group.
        const filesForm = this.form.get('files') as FormGroup<FileFormFields>;
        filesForm.patchValue({
            photoPayslipId: application.photoPayslipId || null,
            photoPayslip: application.photoPayslip || null,
            loanAgreementId: application.loanAgreementId || null,
            loanAgreement: application.loanAgreement || null,
        });

        if (application.loanAgreement) {
            // Format name and size.
            this.loanAgreementModel.set({
                // E.g: 1738747871524-Signed-Quotation-and-Agreement -> Signed Quotation and Agreement
                filename: application.loanAgreement.name?.replace(/-/g, ' ').replace(/\d+/g, '') || '',
                size: formatBytes(application.loanAgreement.size),
                contentUrl: application.loanAgreement.contentUrl
            });
        }

        // Mark each form as dirty.
        this.customerForm.markAsDirty();

        setTimeout(() => {
            // Mark each form as pristine.
            this.form.markAsPristine();
            this.form.markAsUntouched();

            // Update each form's validity.
            this.customerForm.updateValueAndValidity();
            this.bankForm.updateValueAndValidity();
            this.loanForm.updateValueAndValidity();

            this.updateCustomerTypeFlag();

            this.onAccountNumberKeyUp(); // Enable/disable account type based on user's input.

            // this.calculateInstallationOnForm();

            // Mark forms as pristine.
            setTimeout(() => {
                this.markFormsAsPristine();
                if (saveAfterLoan) {
                    this.saveApplication(false, 'Fees updated - Application saved.');
                }

                this.refreshInstalments();
            });
        });

    }

    /**
     * Creates a new personal details form group.
     *
     * @param {CustomerType} customerType The type of customer this form is for.
     * @param {*} [patchData] Optional data to patch the form with.
     * @return {FormGroup} The new form group.
     */
    private newPersonalDetailsForm(customerType: CustomerType, patchData?: VendorApplicationCustomer): FormGroup<PatientDetailsFormFields> {

        const miscResources = toMiscResources((<any>patchData)?.resources);


        const formGroup = this.fb.group<PatientDetailsFormFields>({
            id: new FormControl<number | null>(patchData?.id || null),

            address: new FormControl<string | null>(patchData?.address || null),
            customerType: new FormControl<CustomerType | null>(patchData?.customerType || customerType),
            email: new FormControl<string | null>(patchData?.email || null, Validators.compose([Validators.email, Validators.required])),
            firstName: new FormControl<string | null>(patchData?.firstName || null, Validators.required),
            identityNumber: new FormControl<string | null>(patchData?.identityNumber || null, Validators.compose([Validators.required, isRSAIdentity()])),
            identityType: new FormControl<IdentificationType | null>(patchData?.identityType || null, Validators.compose([Validators.required, Validators.min(1)])),
            lastName: new FormControl<string | null>(patchData?.lastName || null, Validators.required),
            maritalStatus: new FormControl<MaritalStatus | null>(patchData?.maritalStatus || null),
            mobileNumber: new FormControl<string | null>(patchData?.mobileNumber || null, Validators.compose([Validators.required, PhoneNumberValidator('ZA')])),
            postalCode: new FormControl<string | null>(patchData?.postalCode || null),
            title: new FormControl<Title | null>(patchData?.title || null),

            // Validation is manually done as the file step is later in the wizard.
            photoIDBookId: new FormControl<number | null>(patchData?.photoIDBookId || null), // required for customer, not patient.
            photoIDBook: new FormControl<Resource | null>((<any>patchData)?.photoIDBook || null), // required, not patient

            photoPatientCardId: new FormControl<number | null>(patchData?.photoPatientCardId || null), // required for patients.
            photoPatientCard: new FormControl<Resource | null>(patchData?.photoPatientCard || null), // required for patients.

            photoLabOrderId: new FormControl<number | null>(patchData?.photoLabOrderId || null), // required
            photoLabOrder: new FormControl<Resource | null>(patchData?.photoLabOrder || null), // required
            vendorApplicationCustomerResources: new FormControl<VendorApplicationCustomerResource[] | null>(miscResources || null), // Optional

            signaturePatient: new FormControl<Resource | null>(patchData?.signaturePatient || null), // optional
            signaturePatientId: new FormControl<number | null>(patchData?.signaturePatientId || null), // optional

            // Set manually after first save.
            vendorApplicationId: new FormControl<number | null>(patchData?.vendorApplicationId || null), // required
        });

        if (patchData && patchData.identityNumber) {
            setTimeout(() => {
                // set the ID again since the state management will clear it.
                formGroup.get('identityNumber')?.setValue(patchData.identityNumber);
            });
        }

        return formGroup;
    }

    public updateFileFormsValidity(isValid: boolean) {
        this.areFileFormsValid = isValid;
    }

    public updateSignatureFormsValidity(isValid: boolean) {
        this.signatureStepperFrom.get('allSignatures')?.setValue(isValid);
        this.signatureStepperFrom.get('allSignatures')?.updateValueAndValidity();
        this.signatureStepperFrom.updateValueAndValidity();
        this.areSignatureFormsValid = isValid;
    }

    private setReviewModel(): void {
        const patients: any[] = [];

        // (this.isCustomerAPatient ? this.patientsArray.controls : this.patientsArrayWithoutCustomer)
        (this.patientsArray.controls)
            // Remove authorizer from the review model.
            .filter((c, i) => c.get('customerType')?.value !== CustomerType.Authorizer)
            .forEach((patientForm, i) => {
                patients.push({
                    title: toTitle(patientForm.get('title')?.value),
                    initials: this.toInitials(patientForm.get('firstName')?.value),
                    firstName: patientForm.get('firstName')?.value,
                    lastName: patientForm.get('lastName')?.value,
                    identityNumber: patientForm.get('identityNumber')?.value,
                    email: patientForm.get('email')?.value,
                    maritalStatus: this.toMaterialStatus(patientForm.get('maritalStatus')?.value),
                    mobileNumber: patientForm.get('mobileNumber')?.value,
                    address: patientForm.get('address')?.value,
                    postalCode: patientForm.get('postalCode')?.value,
                });
            });

        this.reviewModel.set({
            customer: {
                title: toTitle(this.customerForm.get('title')?.value),
                initials: this.toInitials(this.customerForm.get('firstName')?.value),
                firstName: this.customerForm.get('firstName')?.value,
                lastName: this.customerForm.get('lastName')?.value,
                identityNumber: this.customerForm.get('identityNumber')?.value,
                email: this.customerForm.get('email')?.value,
                maritalStatus: this.toMaterialStatus(this.customerForm.get('maritalStatus')?.value),
                mobileNumber: this.customerForm.get('mobileNumber')?.value,
                address: this.customerForm.get('address')?.value,
                postalCode: this.customerForm.get('postalCode')?.value,
            },

            employment: {
                designation: this.employmentForm.get('designation')?.value,
                employer: this.employmentForm.get('employer')?.value,
                branchPhone: this.employmentForm.get('employerTelephone')?.value,
                employeeNumber: this.employmentForm.get('employeeNumber')?.value,
                payCycle: this.toPayCycle(this.employmentForm.get('payCycleId')?.value),
                payDate: this.toPayDate(this.employmentForm.get('payDay')?.value),
                startDate: this.employmentForm.get('employmentStartDate')?.value,
                address: this.employmentForm.get('employerAddress')?.value,
                postalCode: this.employmentForm.get('employerPostalCode')?.value,
            },

            bankDetails: {
                bank: this.toBank(this.bankForm.get('bankId')?.value),
                branchCode: this.bankForm.get('branchCode')?.value,
                accountType: this.toAccountType(this.bankForm.get('bankAccountType')?.getRawValue()),
                accountNumber: this.bankForm.get('bankAccountNumber')?.value,
                accountHolderFirstName: this.bankForm.get('accountHolderFirstName')?.value,
                accountHolderLastName: this.bankForm.get('accountHolderLastName')?.value,
                accountHolderIdentityType: this.toIdType(this.bankForm.get('accountHolderIdentityType')?.value),
                accountHolderIdentityNumber: this.bankForm.get('accountHolderIdentityNumber')?.value,
            },

            loan: {
                amount: this.loanForm.get('loanAmount')?.value,
                initiationFee: this.loanForm.get('initiationFee')?.value,
                administrationFee: this.loanForm.get('administrationFee')?.value,
                instalment: this.loanForm.get('instalment')?.value,
                instalments: this.loanForm.get('instalments')?.value,
                startDate: this.loanForm.get('startDate')?.value,
            },

            patients: patients,

        });
    }

    private markFormsAsPristine(): void {
        this.form.markAsPristine();
        this.customerForm.markAsPristine();
        this.employmentForm.markAsPristine();
        this.patientsArray.markAsPristine();
        this.bankForm.markAsPristine();
        this.loanForm.markAsPristine();
        this.form.get('files')?.markAsPristine();
        this.fileStepperForm.markAsPristine();
        this.signatureForm?.markAsPristine();
        this.signatureStepperFrom.markAsPristine();
    }

    /**
     * This function will change the invokeMarkSignaturesDirty variable from false to true, and back to true again.
     * This will trigger the signature form to update the validation indicators of the form to be RED instead of Orange/warning to draw more attention.
     * 
     * This is meant only to be used in conjunction with stepping before completing the form.
     */
    private markSignaturesDirty(): void {
        this.invokeMarkSignaturesDirty = true;

        setTimeout(() => {
            this.invokeMarkSignaturesDirty = false;
        }, 50);
    }

    public setSignElectronically(): void {
        this.signingMethod = SigningMethod.Electronic;
        this.localStorageRef?.setItem('signingMethod', SigningMethod.Electronic + '');
        this.updateManualSigningValidationStatus();
    }

    public setSignManually(): void {
        this.signingMethod = SigningMethod.Manual;
        this.localStorageRef?.setItem('signingMethod', SigningMethod.Manual + '');
        this.updateManualSigningValidationStatus();
    }

    private updateManualSigningValidationStatus() {
        let isValid = false;

        if (this.signingMethod === SigningMethod.Manual) {
            isValid = this.form.controls['files'].get('loanAgreement')?.value !== null;
        } else if (this.signingMethod === SigningMethod.Electronic) {
            // Do nothing?
        }

        this.updateSignatureFormsValidity(isValid);
    }

    //#endregion
    //#region Getters and Filters
    // Getter functions and filter methods/functions.

    /**
     * Returns the patients form array.
     *
     * @readonly
     */
    public get patientsArray() {
        return this.form.controls["patients"];
    }

    public get patientsArrayWithoutCustomer() {
        const allPatients = this.form.controls["patients"];
        const controls = allPatients.controls;

        return controls.filter((c, i) => i !== 0);
    }

    public get patientsArrayWithoutCustomerOrAuthorizer() {
        const allPatients = this.form.controls["patients"];
        const controls = allPatients.controls;

        return controls.filter((c, i) => i !== 0 && (c.value as any)?.customerType !== CustomerType.Authorizer);
    }

    private findPatientFormIndexByPatientId(patientId: number) {
        const allPatients = this.form.controls["patients"];
        const controls = allPatients.controls;

        for (let i = 0; i < controls.length; i++) {
            const control = controls[i];
            if (control.get('id')?.value === patientId) {
                return i;
            }
        }

        return -1;
    }

    public get signatureForm() {
        return this.form.get('signatures') as FormGroup<SignatureFormFields>;
    }

    public installmentOptions(payCycleId: PayCycle | null | undefined): DisplayValue<number>[] {
        if (payCycleId === null || payCycleId === undefined) return [];

        switch (payCycleId) {
            case PayCycle.Monthly:
                return this.monthlyPayCycleInstallments;
            case PayCycle.Weekly:
                return this.weeklyPayCycleInstallments;
            case PayCycle.Fortnightly:
                return this.fortnightlyPayCycleInstallments;
            default:
                return [];
        }
    }

    public patientErrorMessage(): string {
        // Only valid patients or the customer patient if the customer is also a patient.
        const filtered = this.patientsArray.controls
            .filter(control => {
                const fValue = control.getRawValue() as any;
                return fValue
                    && (fValue.customerType === CustomerType.PatientDebtorAndAuthorizer
                        || fValue.customerType === CustomerType.PatientAndDebtor
                        || fValue.customerType === CustomerType.Patient);
            });


        return filtered.length > 0 ? 'Please complete the required fields.' : 'At least one patient is required.';
    }

    /**
     * The user will be given options like: “This Month”, “Next Month” etc.
     * The system will then calculate the actual date from the pay date and option selected. 
     * Example, if 25th is selected for next month (May), then the start date is 25 May 2024. 
     * Similarly for weekly and fortnightly paid.
     *
     * @readonly
     */
    public setStartDateOptions(payDayParam?: number, payCycleIdParam?: PayCycle): void {
        if (!this.employmentForm?.get('payDay')?.value || !this.employmentForm?.get('payCycleId')?.value
            && !payDayParam && !payCycleIdParam) return;

        const payDay = payDayParam || this.employmentForm.get('payDay')?.value;
        const payCycleId = payCycleIdParam || this.employmentForm.get('payCycleId')?.value;
        if (!payDay || !payCycleId) return;

        const newOpts: any[] = [];

        let today = dayjs().startOf('day');
        const isEndOfMonth = payDay === -1;
        if (payCycleId === PayCycle.Monthly) {
            if (isEndOfMonth) {
                today = today.endOf('month');
            } else {
                today = today.date(payDay);
            }

            // If the adjusted "today" is in the past, add a month.
            if (today.isBefore(dayjs())) {
                today = today.add(1, 'month');
            }
        } else {
            // Set day of week.
            today = today.day(payDay);

            // If the adjusted "today" is in the past, add a week.
            if (today.isBefore(dayjs())) {
                today = today.add(1, 'week');
            }
        }

        if (payCycleId === PayCycle.Monthly) {
            for (let i = 0; i < 4; i++) {
                let date = today.add(i, 'months').startOf('day');

                if (isEndOfMonth) { // This means it will always be the last day of the month.
                    date = date.endOf('month').startOf('day');
                } else if (payDay > 28) {
                    // Dates like 31st of the month can be problematic.
                    if (date.daysInMonth() < payDay) {
                        date = date.endOf('month').startOf('day');
                    } else {
                        date = date.date(payDay).startOf('day');
                    }
                }

                newOpts.push({ value: date.toDate(), display: date.format('DD MMMM YYYY') });
            }
        } else if (payCycleId === PayCycle.Weekly || payCycleId === PayCycle.Fortnightly) {
            for (let i = 0; i < 12; i++) {
                const date = today.add(i, 'weeks').startOf('day');
                newOpts.push({ value: date.toDate(), display: date.format('DD MMMM YYYY') });
            }
        }

        this.loanStartDateOptions = newOpts;
    }

    //#endregion
    //#region Change Detection
    // Deep config comparisons, change log generation, hasChangesFn, etc.

    //#endregion    
    //#region Parsing and Validation
    // Transformation/mapping methods
    // Methods returning true/false: isCurrent, areFeedsEqual, shouldProcess, etc.

    /**
     * Converts the pay cycle value to a human-readable string.
     *
     * @param {(number | string | null)} [value] The value to convert.
     * @return {string} The human-readable string.
     */
    public toIdType(value?: number | string | null): string {
        return this.idTypeOptions.find(id => id.value === value)?.display || '';
    }

    /**
     * Converts the marital status value to a human-readable string.
     *
     * @param {(number | null | unknown)} [value] The value to convert.
     * @return {string} The human-readable string.
     */
    public toMaterialStatus(value?: number | null | unknown): string {
        return this.maritalStatuses.find(id => id.value === value)?.display || '';
    }

    /**
     * Converts the pay cycle value to a human-readable string.
     *
     * @param {(Title | null)} [value] The value to convert.
     * @return {string} The human-readable string.
     */
    public toTitle(value?: Title | null): string {
        return toTitle(value);
    }

    public toInitials(names: string | null | undefined) {
        if (!names) return '';

        const initials = names.split(' ').map(n => n[0]).join('');
        return initials;
    }

    /**
     * Converts the pay cycle value to a human-readable string.
     * 
     * @param bankId The value to convert.
     * @returns The human-readable string.
     */
    public toBank(bankId?: number | null): string {
        return this.bankOptions.find(bank => bank.id === bankId)?.name || '';
    }

    /**
     * Converts the bank account type value to a human-readable string.
     *
     * @param {(BankAccountType | null)} [accountType] The value to convert.
     * @return {string} The human-readable string.
     */
    public toAccountType(accountType?: number | BankAccountType | null): string {
        if (!accountType) return '';

        return this.bankAccountTypeOptions.find(opt => opt.value === accountType)?.display || '';
    }

    /**
     * Converts the pay cycle value to a human-readable string.
     *
     * @param {(PayCycle | null)} [value] The value to convert.
     * @return {string} The human-readable string.
     */
    public toPayCycle(value?: PayCycle | null): string {
        return this.payCyclesOptions.find(cycle => cycle.value === value)?.display || '';
    }

    /**
     * Converts the pay date value to a human-readable string.
     * @param payDay The value to convert.
     * @returns The human-readable string.
     */
    public toPayDate(payDay?: number | null): string {
        const payCycleId = this.employmentForm.get('payCycleId')?.value;
        if (!payCycleId) return '';

        if (payCycleId === PayCycle.Weekly || payCycleId === PayCycle.Fortnightly) {
            return WeeklyPayDateOptions.find(d => d.value === payDay)?.display || '';
        } else {
            const match = MonthlyPayDateOptions.find(d => d.value === payDay)?.display || '';
            if (payDay !== -1) {
                return toNth(payDay || 1) + '';
            }

            return match;
        }
    }

    /**
     * Enables or disables the pay date field based on the pay cycle selected.
     */
    private enablePayCycleAndPayDateValidators(): void {
        this.form.controls['employment'].get('payCycleId')?.valueChanges
            .pipe(
                startWith(null),
                filter(() => !this.isReadMode && this.form.controls['employment'].enabled),
                takeUntil(this.destroyed$)
            )
            .subscribe((value => {
                if ((value === null || !PayCycle[value])) {
                    const initialCycle = this.form.controls['employment'].get('payCycleId')?.value;

                    // If the initial value is invalid, do nothing.
                    // This can happen if the form is pre-populated with valid data and the startWith could create confusion.
                    if (initialCycle && !PayCycle[initialCycle]) return;

                    this.form.controls['employment'].get('payDay')?.disable();
                } else {
                    this.form.controls['employment'].get('payDay')?.enable();
                    this.form.controls['employment'].get('payDay')?.setValue(null);
                }

                this.form.controls['employment'].get('payDay')?.updateValueAndValidity();
            }));
    }

    /**
     * Enables or disables the ID field based on the ID type s-elected.
     *
     * @param {FormGroup} formGroup The form group to enable/disable the ID field for.
     * @param {number} index The index for tracking the subscription.
     */
    private enableIdStateManagementForGroup(formGroup: FormGroup, index: number, isReinstantiating = false): void {
        const sub = formGroup.controls['identityType']?.valueChanges
            .pipe(
                startWith(null),
                filter((val) => !this.isReadMode && formGroup.controls['identityType'].enabled && (!isReinstantiating
                    // Skip the "startWith" if the form is pre-populated with valid data.
                    || (isReinstantiating && val !== null)
                )),
                takeUntil(this.destroyed$)
            )
            .subscribe((value => {
                // Reset the ID field when the ID type changes.
                formGroup.controls['identityNumber']?.setValue(null);

                if ((value === null || !IdentificationType[value])) {
                    const initialIdType = formGroup.controls['identityType']?.value;

                    // If the initial value is invalid, do nothing.
                    // This can happen if the form is pre-populated with valid data and the startWith could create confusion.
                    if (initialIdType && !PayCycle[initialIdType]) return;

                    formGroup.controls['identityNumber']?.disable();
                } else {
                    formGroup.controls['identityNumber']?.enable();
                }

                formGroup.controls['identityNumber']?.updateValueAndValidity();
            }));

        // Save the subscription based on the index.
        if (index !== undefined) {
            /**
             * @see idStateSubscriptions for more information.
             */
            const indexStr = index + '';

            // Remove old subscription if it exists.
            if (this.idStateSubscriptions[indexStr] !== undefined) this.idStateSubscriptions[indexStr]?.unsubscribe();

            // Save the new subscription.
            this.idStateSubscriptions[indexStr] = sub;
        }
    }

    /**
     * Enables the patients form validation and updates the MatStepper based on the validity of the patients.
     */
    private enablePatientsFormValidation() {
        this.patientsArray.statusChanges
            .pipe(takeUntil(this.destroyed$))
            .subscribe(() => {
                // Only valid patients or the customer patient if the customer is also a patient.
                const filtered = this.patientsArray.controls
                    .filter(control => {
                        const fValue = control.getRawValue() as any;
                        return fValue
                            && (fValue.customerType === CustomerType.PatientDebtorAndAuthorizer
                                || fValue.customerType === CustomerType.PatientAndDebtor
                                || fValue.customerType === CustomerType.Patient);
                    });

                // Check if each form is valid and update the patientStepperForm.
                const allPatientsValid = filtered.length > 0 &&
                    filtered.every(control => control.valid ||
                        // If it's the customer patient, then it's valid if the customer form is valid.
                        (control.disabled && (control?.value || {}).identityNumber === this.customerForm.get('identityNumber')?.value && this.customerForm.valid));

                const previousValue = this.patientStepperForm.get('allPatients')?.value;

                if (previousValue !== allPatientsValid) {
                    this.patientStepperForm.get('allPatients')?.setValue(allPatientsValid);
                    this.patientStepperForm.get('allPatients')?.updateValueAndValidity();
                    this.patientStepperForm.updateValueAndValidity();
                }

            });
    }

    /**
     * Subscribes to the statusChanges of the provided controls and saves the values to the server when all controls are valid.
     *
     * @param {(...Array<AbstractControl | null>)} controls The control(s) to subscribe to.
     */
    private enableAutoSaveForControls(skipQualifier = () => false, ...controls: Array<AbstractControl | null>): void {
        // Filter out null controls.
        if (!controls || controls.some(c => c === null)) { console.warn('Could not subscribe to one or more null controls. Auto-save will not work.'); return; }

        // Filter out null controls and subscribe to their valueChanges.
        const nonNullControls = controls.filter(control => control !== null) as AbstractControl[];

        // Combine the latest for each control.
        combineLatest(nonNullControls.map(control => control.statusChanges.pipe(startWith(control.status))))
            .pipe(
                debounceTime(500),
                filter(statuses => statuses.every(status => status === 'VALID')),
                skip(this.isNewApplication ? 0 : 1), // Conditionally skip the first one as it's the initial state.
                skipWhile(skipQualifier),
                takeUntil(this.destroyed$)
            )
            .subscribe((statuses) => {
                // Save the value to the server if all controls are valid.
                // this.showSaveMessage('Auto Save (SKIPPED)');
                this.saveApplication();
            });
    }

    /**
     * Subscribes to the statusChanges of the provided form and saves the values to the server when the form is valid.
     *
     * @param {FormGroup} form The form to subscribe to.
     * @param {() => boolean} [skipQualifier] Optional function to determine if the save should be skipped. FALSE = don't skip, TRUE = skip.
     * @param {string} formName Name of form control for development purposes / logging.
     */
    private enableAutoSaveForForm(form: FormGroup | FormArray, skipQualifier = () => false, formName?: string): void {
        form.statusChanges
            .pipe(
                debounceTime(500), // Debounce to prevent multiple saves.
                filter(status => status === 'VALID'), // We only care when the status is VALID.
                skip(this.isNewApplication ? 0 : 1), // Conditionally skip the first one as it's the initial state.
                skipWhile(skipQualifier), // Parameterized skip function.
                takeUntil(this.destroyed$)
            )
            .subscribe(() => {
                // Save application if the form is valid. Queueing is handled by CaptureSaveService.
                this.saveApplication();
            });
    }

    /**
     * Subscribes to the valueChanges of the customer information form and auto-syncs the values to the patient form if the customer is also a patient.
     */
    private enableAutoSyncValuesForCustomerAndPatient0() {
        this.form.get('customerInformation')?.valueChanges
            // .pipe(filter(() => this.isCustomerAPatient), takeUntil(this.destroyed$))
            .pipe(takeUntil(this.destroyed$))
            .subscribe((value) => {
                const patientForm = this.form.get('patients')?.get('0');
                if (patientForm && value) {
                    patientForm.patchValue({
                        address: value.address,
                        customerType: value.customerType,
                        email: value.email,
                        firstName: value.firstName,
                        identityType: value.identityType,
                        identityNumber: value.identityNumber,
                        lastName: value.lastName,
                        maritalStatus: value.maritalStatus,
                        mobileNumber: value.mobileNumber,
                        photoIDBook: value.photoIDBook,
                        photoIDBookId: value.photoIDBookId,
                        photoLabOrder: value.photoLabOrder,
                        photoLabOrderId: value.photoLabOrderId,
                        photoPatientCard: value.photoPatientCard,
                        photoPatientCardId: value.photoPatientCardId,
                        postalCode: value.postalCode,
                        title: value.title,
                        vendorApplicationCustomerResources: value.vendorApplicationCustomerResources,
                        vendorApplicationId: value.vendorApplicationId,
                    } as any);
                    // Strange error where this is not detected in the patchValue...
                    (<any>patientForm).controls['identityNumber']?.setValue(value.identityNumber);
                }
            });
    }

    /**
     * Patient 0 should not be interactive from the patient's tab.
     */
    private disablePatient0() {
        // Disable the first patient form if the customer is also a patient.
        this.patientsArray.controls[0].disable();
    }

    /**
     * Uses the index to determine if the form for the given step is invalid or not.
     *
     * @return {boolean} true if invalid, otherwise false.
     */
    public formAtIndexInvalid(index = this.currentStep): boolean {
        if (index === 0) return this.customerForm.invalid;
        if (index === 1) return this.employmentForm.invalid;
        if (index === 2) return this.patientsArray.invalid;
        if (index === 3) return this.bankForm.invalid;
        if (index === 4) return this.loanForm.invalid;
        if (index === 5) return !this.areFileFormsValid;
        // if (index === 5) return this.form.get('files').invalid;
        return false;
    }

    public formAtIndex(index = this.currentStep) {
        if (index === 0) return this.customerForm;
        if (index === 1) return this.employmentForm;
        if (index === 2) return this.patientsArray;
        if (index === 3) return this.bankForm;
        if (index === 4) return this.loanForm;
        if (index === 5) return this.fileStepperForm;
        if (index === 6) return this.signatureForm;

        return null;
    }

    private toVendorApplication() {
        let application: Partial<VendorApplication> = {};
        const formData = this.form.getRawValue() as any;
        // The Customer (Debtor), Account Holder and Patients are all kept in the patients array.
        // The only thing that separates them is the customerType field value. 
        application = this.addPatientsToApplication(application);
        application = { ...application, ...this.employmentForm.getRawValue() as any };
        application = { ...application, ...this.loanForm.getRawValue() as any };
        application = { ...application, ...this.extractBankDetails() };

        if (!this.isCustomerTheAccountHolder) { // If the customer is not the account holder, create one.
            const raw = this.bankForm.getRawValue();
            const patientLike = {
                firstName: raw.accountHolderFirstName,
                lastName: raw.accountHolderLastName,
                identityType: raw.accountHolderIdentityType,
                identityNumber: raw.accountHolderIdentityNumber,
                customerType: CustomerType.Authorizer,
                id: raw.accountHolderEntityId || null,
            } as Partial<VendorApplicationCustomer>;
            application.patients?.push(patientLike as VendorApplicationCustomer);
            application.bankAccountCustomerId = (patientLike.id || null) as number | undefined;
            // TODO ask Aharon about this scenario:
            // 1. An account holder existed and its ID was set on bankAccountCustomerId, was then deleted.
            // 2. No save on the frontend yet, but the backend will change the bankAccountCustomerId to null.
            // 3. The Application gets saved with the debtorCustomerID set on bankAccountCustomerId.
            // 4. A new account holder is created (CustomerType 4) and the application is saved with the new patient who has a NULL ID at this point.
            // 5. Does the server recognize the new patient with CustomerType=4 should be set at the bankAccountCustomerId?
        } else {
            application.bankAccountCustomerId = formData.debtorCustomerId || null;
        }

        application = { ...application, ...formData.signatures as any };
        application = { ...application, ...this.form.controls['files'].getRawValue() as any };

        application = {
            ...application,
            vendorId: formData.vendor || null,
            vendorAgentId: formData.agent || null,
            debtorCustomerId: formData.debtorCustomerId || null,
            // loanAgreementId: formData.loanAgreementId || null,
            reference: formData.reference || null,
            id: formData.id || null,
        };

        // Remove these resource objects from the form data.
        // signatureMandate
        // signatureQuotation
        // signatureTerms
        delete application.signatureMandate;
        delete application.signatureQuotation;
        delete application.signatureTerms;
        delete application.photoPayslip;
        delete application.loanAgreement;

        return application;
    }

    private extractBankDetails(): Partial<VendorApplication> {
        const raw = this.bankForm.getRawValue();

        return {
            bankId: raw.bankId,
            branchCode: raw.branchCode,
            bankAccountType: raw.bankAccountType,
            bankAccountNumber: raw.bankAccountNumber,
        } as Partial<VendorApplication>;
    }

    private addPatientsToApplication(application: Partial<VendorApplication>) {
        application.patients = application.patients || [];
        this.patientsArray.getRawValue().forEach(patient => {
            const pForm = patient as any;
            // Remove any Resource objects from the form data.
            delete pForm.photoIDBook;
            delete pForm.photoLabOrder;
            delete pForm.photoPatientCard;
            delete pForm.signaturePatient;
            if (pForm.vendorApplicationCustomerResources) {
                pForm.vendorApplicationCustomerResources.forEach((res: any) => {
                    delete res.resource;
                    // The upload handler stamps vendorApplicationCustomerId from baseForm at upload time,
                    // which is null when the patient was created in the same session. By the time we
                    // serialise, the patient has an id (from a prior save or about to be created), so
                    // bind it here to avoid an FK violation on the join table.
                    if (res.vendorApplicationCustomerId == null && pForm.id != null) {
                        res.vendorApplicationCustomerId = pForm.id;
                    }
                });
            }

            application.patients?.push(pForm);
        });

        return application;
    }

    //#endregion
    //#region Response Handlers
    // API/NGRX callback handlers.

    /**
     * Shows a snackbar message indicating that the application has been auto-saved.
     */
    private showSaveMessage(message?: string): void {
        this.matSnackbar.openFromComponent(SnackMessageComponent, {
            duration: 2000,
            data: {
                message: message || 'Auto saved.',
                closeText: 'Dismiss'
            }
        });
    }

    //#endregion
    //#region Navigation
    // Confirmation close dialogs, router guards, etc.

    private asyncConfirm(title: string, description: string): Promise<boolean> {
        return firstValueFrom(this.dialog.open(ConfirmDialog, {
            data: {
                title: title,
                description: description,
                confirmResultData: true
            }
        }).afterClosed());
    }

    /**
     * Enables the dialog to confirm and auto-save the application when not submitting on close.
     */
    private enableOnCloseConfirmAndSave() {
        // Confirm close if the form is dirty.
        this.dialogRef.disableClose = true;
        this.dialogRef.backdropClick()
            .pipe(takeUntil(this.destroyed$))
            .subscribe(async () => {
                this.confirmCloseIfDirty();
            });

        // Save application on dialog close if not submitting.
        this.dialogRef.beforeClosed()
            .pipe(takeUntil(this.destroyed$))
            .subscribe(async () => {
                // If the dialog closes from auto close (submit), or if the form is invalid, do not save.
                if (!this.isSubmitting && this.formAtIndexInvalid() === false) {
                    // await this.saveApplication();
                }
            });
    }

    //#endregion
    //#region Post Instantiation
    // Post-init fetch requests, used in such as landing page, after view init, etc.

    //#endregion

    public ngOnDestroy(): void {
        this.destroyed$.next();
        this.destroyed$.complete();
    }

}


interface CaptureDialogInputData {
    readMode: boolean;
    application?: VendorApplication;
    vendorAgentId?: number;
    agent?: VendorAgent;
    vendor?: Vendor;
}
/**
 * Maps the flat misc-document rows from the search/load response into form entries.
 * Each row carries both the join-row `id` and the `resourceId`; `resource.id` must be the Resource id,
 * never the row id, or anything reading `resource.id` (e.g. file removal) links the wrong Resource.
 */
function toMiscResources(rows: MiscResourceRow[] | null | undefined): VendorApplicationCustomerResource[] {
    return (rows || []).map(r => ({
        id: r.id,
        resourceId: r.resourceId,
        vendorApplicationCustomerId: r.vendorApplicationCustomerId,
        resource: {
            id: r.resourceId,
            name: r.name,
            size: r.size,
            extension: r.extension,
            contentType: r.contentType,
            contentUrl: r.contentUrl,
        },
    } as VendorApplicationCustomerResource));
}

/** Shape of a misc-document row in the `resources` array returned by vendorApplication/search. */
interface MiscResourceRow {
    id: number;
    vendorApplicationCustomerId: number;
    resourceId: number;
    name: string;
    size: number;
    extension: string;
    contentType: string;
    contentUrl: string;
}
